<template>
    <div class="ntpReport">
        <template v-if="userPermission == 1">
            <div class="ntpReport-header">
                <lgn-input class="ntpReport-header-search" placeholder="請輸入場站代碼" v-model="searchText"
                :suffix="true" :suffix-icon="'el-icon-search'" :suffix-method="searchNtpReport"
                @keyup.enter.native="searchNtpReport"></lgn-input>
                <a :href="`https://s3-ap-northeast-1.amazonaws.com/s3.paca.com.tw/period_report/${userInfo.id}_${serverTime}.tgz`" v-if="haveService" class="ntpReport-header-download main-button" target="_blank">當月報表 <i class="el-icon-download"></i></a>
            </div>
            <div class="paca-table">
                <div class="paca-table__header">
                    <div class="paca-table__header-item item-column column-name">{{$t("table.header.siteName")}}</div>
                    <div class="paca-table__header-item item-column column-site">{{$t("table.header.site")}}</div>
                    <div class="paca-table__header-item item-column column-vendor">{{$t("table.header.vendor")}}</div>
                    <div class="paca-table__header-item item-column column-report">報表</div>
                    <div class="paca-table__header-item item-column column-pause">停用</div>
                </div>
                <div class="paca-table__body" v-if="ntpListView.length != 0">
                    <div class="paca-table__body-col" v-for="(item, index) in ntpListView" :key="ntpSearchMode+index">
                        <div class="paca-table__body-col-list">
                            <div class="paca-table__body-col-list-item item-column column-name overflow-text">{{item.name}}</div>
                            <div class="paca-table__body-col-list-item item-column column-site">{{item.site}}</div>
                            <div class="paca-table__body-col-list-item item-column column-vendor">{{item.vendor}}</div>
                            <div class="paca-table__body-col-list-item item-column column-report">
                                <a :href="`https://s3-ap-northeast-1.amazonaws.com/s3.paca.com.tw/period_report/${item.site}_${serverTime}.tgz`" target="_blank" :download="`${item.site}_${serverTime}.tgz`" class="el-icon-receiving column-report-icon"></a>
                            </div>
                            <div class="paca-table__body-col-list-item item-column column-pause">
                                <button class="column-pause-icon" @click="closeNtpreport(item, index)"></button>
                            </div>
                        </div>
                    </div>
                    <button type="button" class="paca-table__body-more" v-if="isShowMoreButton" @click="ntpReportListIteration()">更多</button>
                </div>
                <div class="paca-table__empty" v-else></div>
            </div>
        </template>
        <template v-else-if="userPermission == 0">
            <div class="ntpReport-description">
                <div class="ntpReport-description-item">
                    <p class="ntpReport-description-item-title">什麼是新北報表</p>
                    <p class="ntpReport-description-item-content">
                        因應新北市政府對各停車場分時、延時回報規定，該服務讓使用者下載可直接回報給新北市政府的統計報表，減少人工作業的時間。使用者亦可針對各單一場站，決定是否啟用新北報表功能。
                    </p>
                </div>
                <div class="ntpReport-description-item apply">
                    <button type="button" class="main-button" @click="openApplyDialog()" :disabled="!canAddNewApplyItem">{{canAddNewApplyItem ? '我要申請' : '已申請'}}</button><p class="ntpReport-description-item-supplement">申請後可至<router-link class="ntpReport-description-item-supplement-link" :to="{name: 'AccountInfo'}">「我的帳戶」</router-link>中查看結果或修改資料</p>
                </div>
                <div class="ntpReport-description-item image">
                    <div class="ntpReport-description-item-image desckop"></div>
                    <div class="ntpReport-description-item-image mobile"></div>
                </div>
            </div>
        </template>
        <template v-else-if="userPermission == -1"></template>
        <div class="ntpReport-single-apply" v-if="isApplySinglePage">
            <div class="ntpReport-single-apply__header">
                <button type="button" class="ntpReport-single-apply__header-icon el-icon-back" @click="closeApplySinglePage"></button>
                <div class="ntpReport-single-apply__header-text">啟用新北報表</div>
            </div>
            <div class="ntpReport-single-apply__body">
                <div class="ntpReport-single-apply__body-description">
                    為確保資料使用之安全性，新北報表服務需要核對會員身分。<br />請提供以下資訊，我們將為您開啟此功能
                </div>
                <div class="ntpReport-single-apply__body-form">
                    <div class="ntpReport-single-apply__body-form-item">
                        <div class="ntpReport-single-apply__body-form-item-label">聯絡人電話</div>
                        <lgn-input class="ntpReport-single-apply__body-form-item-value" v-model="companyInfo.contact_number"></lgn-input>
                    </div>
                    <div class="ntpReport-single-apply__body-form-item">
                        <div class="ntpReport-single-apply__body-form-item-label">公司名稱</div>
                        <lgn-input class="ntpReport-single-apply__body-form-item-value" v-model="companyInfo.company_name"></lgn-input>
                    </div>
                    <div class="ntpReport-single-apply__body-form-item">
                        <div class="ntpReport-single-apply__body-form-item-label">統一編號</div>
                        <lgn-input class="ntpReport-single-apply__body-form-item-value" v-model="companyInfo.tax_id"></lgn-input>
                    </div>
                    <div class="ntpReport-single-apply__body-form-item">
                        <div class="ntpReport-single-apply__body-form-item-label">營業登記地址</div>
                        <lgn-input class="ntpReport-single-apply__body-form-item-value" v-model="companyInfo.company_address"></lgn-input>
                    </div>
                </div>
            </div>
            <div class="ntpReport-single-apply__footer">
                <button type="button" class="ntpReport-single-apply__fotter-button second-button" @click="closeApplySinglePage">取消</button>
                <button type="button" class="ntpReport-single-apply__footer-button main-button" @click="postCompanyInfo">送出申請</button>
            </div>
        </div>
        <el-dialog class="ntpReport-apply-dialog" :class="{'non-title': isResultShow}" :visible.sync="isApplyDialogOpen">
            <div slot="title">啟用新北報表</div>
            <template v-if="!isResultShow && isApplyDialogOpen">
                <div class="ntpReport-apply-dialog__body">
                    <div class="ntpReport-apply-dialog__body-description">
                    為確保資料使用之安全性，新北報表服務需要核對會員身分。<br />請提供以下資訊，我們將為您開啟此功能
                </div>
                <div class="ntpReport-apply-dialog__body-form">
                    <div class="ntpReport-apply-dialog__body-form-item">
                        <div class="ntpReport-apply-dialog__body-form-item-label">聯絡人電話</div>
                            <lgn-input class="ntpReport-apply-dialog__body-form-item-value" v-model="companyInfo.contact_number"></lgn-input>
                        </div>
                        <div class="ntpReport-apply-dialog__body-form-item">
                            <div class="ntpReport-apply-dialog__body-form-item-label">公司名稱</div>
                            <lgn-input class="ntpReport-apply-dialog__body-form-item-value" v-model="companyInfo.company_name"></lgn-input>
                        </div>
                        <div class="ntpReport-apply-dialog__body-form-item">
                            <div class="ntpReport-apply-dialog__body-form-item-label">統一編號</div>
                            <lgn-input class="ntpReport-apply-dialog__body-form-item-value" v-model="companyInfo.tax_id"></lgn-input>
                        </div>
                        <div class="ntpReport-apply-dialog__body-form-item">
                            <div class="ntpReport-apply-dialog__body-form-item-label">營業登記地址</div>
                            <lgn-input class="ntpReport-apply-dialog__body-form-item-value" v-model="companyInfo.company_address"></lgn-input>
                        </div>
                    </div>
                </div>
                <div class="ntpReport-apply-dialog__footer" slot="footer">
                    <button type="button" class="second-button" @click="closeApplyDialog">取消</button>
                    <button type="button" class="main-button" @click="postCompanyInfo">送出申請</button>
                </div>
            </template>
            <template v-else>
                <div class="ntpReport-apply-dialog__result">
                    <div class="ntpReport-apply-dialog__result-icon">
                        <i :class="resultStatus == 'success' ? 'el-icon-circle-check':'el-icon-warning'"></i>
                    </div>
                    <div class="ntpReport-apply-dialog__result-text">{{resultStatus == 'success' ? '申請成功' : '您已擁有此服務但未啟用請聯絡管理員協助，謝謝'}}</div>
                    <div class="ntpReport-apply-dialog__result-footer">
                        <button class="ntpReport-apply-dialog__result-footer-button main-button" type="button" @click="closeApplyDialog">返回</button>
                    </div>
                </div>
            </template>
        </el-dialog>
    </div>
</template>
<script>
import * as api from '@/script/apiService/api.js'
import lgnInput from '@/lgnComponents/lgnInput/lgnInput.vue'
export default {
    name: "ntpReport",
    components: {
        lgnInput
    },
    data(){
        return{
            ntpList: {
                all: [],
                search: []
            },
            viewNtpList: {
                all: [],
                search: []
            },
            tableLoading: false,
            ntpSearchMode: "all",
            searchText: "",
            viewMoreCount: 0,
            isShowMoreButton: true,
            serverTime: "",
            haveService: true,
            userPermission: -1,
            isApplyDialogOpen: false,
            isApplySinglePage: false,
            isResultShow: false,
            popStateMethod: null,
            companyInfo: {
                contact_number: '',
                company_name: '',
                tax_id: '',
                company_address: ''
            },
            testComapnyStatus: false,
            isUserFirstService: true,
            resultStatus: 'success',
            serviceList: [],
            canAddNewApplyItem: true
        }
    },
    methods: {
        searchNtpReport(){
            this.viewMoreCount = 0;
            this.isShowMoreButton = true;
            let searchText = this.searchText;
            this.ntpSearchMode = "search";
            this.viewNtpList.search = [];
            let searchedList = [];
            this.$nextTick(() => {
                this.tableLoading = true;
            })
            setTimeout(function(){
                this.ntpList.all.forEach(item => {
                    if(item.site.indexOf(searchText) != -1){
                        searchedList.push(item);
                    }
                })
                this.tableLoading = false;
                setTimeout(function(){
                    this.ntpList.search = searchedList;
                    this.ntpReportListIteration();
                }.bind(this), 300);
            }.bind(this), 300);
        },
        ntpReportListIteration(){
            if((this.viewMoreCount + 1)*30 > this.ntpList[this.ntpSearchMode].length){
                this.isShowMoreButton = false;
            }
            this.viewNtpList[this.ntpSearchMode] = this.viewNtpList[this.ntpSearchMode].concat(this.ntpList[this.ntpSearchMode].slice(this.viewMoreCount*30, (this.viewMoreCount + 1) * 30));
            this.viewMoreCount += 1;
        },
        closeNtpreport(item, index){
            this.$confirm(`即將停用 ${item.name} 之新北回報功能`,"停用功能", {
                confirmButtonText: "確認停用",
                confirmButtonClass: "main-button",
                cancelButtonText: "取消",
                cancelButtonClass: "second-button",
                type: 'warning'
            }).then(async () => {
                let data = {
                    id: item.extra_info.id,
                    services_reports : 0
                }
                let res = await api.putAdminRegExtraInfoServiceReport(data);
                if(!res.error_status){
                    this.ntpListView.splice(index,1);
                }else if(res.error_status != '401' && res.error_status != '504'){
                    this.$message.error({
                        showClose: true,
                        duration: 2500,
                        message: "發生錯誤!"
                    });
                }
            }).catch(() => {})
        },
        pageLoading(value){
            let loadingStyle = "full-height";
            let asideWidth = document.querySelector(".el-aside").offsetWidth;
            if(asideWidth > 150){
                loadingStyle += " collapse-open";
            }else if(asideWidth > 50){
                loadingStyle += " collapse-exist";
            }
            if(value == true){
                this.loadingMethod = this.$loading({
                    lock: true,
                    target: '.ntpReport',
                    text: '讀取中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(255,255,255,0.8)',
                    customClass: loadingStyle
                });
            }else{
                if(this.loadingMethod != null){
                    this.loadingMethod.close();
                }
            }
        },
        async openApplyDialog(){
            this.isResultShow = false;
            if(!this.canAddNewApplyItem){
                this.isApplyDialogOpen = true;
                this.resultStatus = 'success';
                this.isResultShow = true;
            } else if(!this.isUserFirstService){
                await this.postCompanyInfo();
                this.isApplyDialogOpen = true;
            } else {
                this.companyInfo = {
                    contact_number: '',
                    company_name: '',
                    tax_id: '',
                    company_address: ''
                };
                if(window.innerWidth <= 480){
                    this.setPopStateMethod();
                    this.isApplySinglePage = true;
                    history.pushState({}, '');
                } else {
                    this.isApplyDialogOpen = true;
                }
                this.$nextTick(() => {
                    document.querySelector(".lgn-input__inner").focus();
                })
            }
        },
        setPopStateMethod(){
            this.popStateMethod = window.addEventListener('popstate', function(){
                this.closeApplySinglePage("browserAction");
            }.bind(this))
        },
        async postCompanyInfo(){
            this.companyInfo.services_name = 'NTPServicesReports';
            let res = await api.postUserService(this.companyInfo);
            if(!res.error_status){
                this.isApplyDialogOpen = true;
                this.isApplySinglePage = false;
                this.resultStatus = 'success';
                this.isResultShow = true;
                await this.getUserService();
                if(this.serviceList.find(item => item.services_title == 'NTP Services Reports' && item.status == 0)){
                    this.canAddNewApplyItem = false;
                }
            } else if(res.error_status == '409'){
                this.isApplyDialogOpen = true;
                this.isApplySinglePage = false;
                this.resultStatus = 'info';
                this.isResultShow = true;
            } else if(res.error_status != '401' && res.error_status != '504'){
                this.$message.error({
                    duration: 2500,
                    showClose: true,
                    message: "發生錯誤!"
                })
            }
        },
        closeApplyDialog(){
            this.isApplyDialogOpen = false;
        },
        closeApplySinglePage(action){
            window.removeEventListener('popstate', this.popStateMethod);
            if(action != "browserAction"){
                history.back();
            }
            this.isApplySinglePage = false;
        },
        changeCompanyResult(){
            if(!this.testComapnyStatus){
                this.res = {

                };
                this.companyInfo = {
                    phone: '0912345678',
                    company_name: 'testABC',
                    tax_id: '12345678',
                    company_address: 'test-a-b-c'
                }
                this.testComapnyStatus = !this.testComapnyStatus;
            } else {
                this.res = {error_status: '400'};
                this.companyInfo = {
                    phone: '',
                    company_name: '',
                    tax_id: '',
                    company_address: ''
                }
                this.testComapnyStatus = !this.testComapnyStatus;
            }
        },
        async getUserCompanyInfo(){
            let res = await api.getUserCompanyInfo();
            if(!res.error_status){
                this.isUserFirstService = false;
                this.companyInfo = res;
            } else if(res.error_status == '404'){
                this.isUserFirstService = true;
            } else if(res.error_status != '401' && res.error_status != '504'){
                this.$message.error({
                showClose: true,
                duration: 2500,
                message: "發生錯誤!"
                })
            }
        },
        async getUserService(){
            let res = await api.getUserService();
            if(!res.error_status){
                this.serviceList = res;
                this.$store.commit({
                type: 'setServiceList',
                serviceList: res
                })
            } else if(res.error_status != '401' && res.error_status != '504'){
                this.$message.error({
                showClose: true,
                duration: 2500,
                message: "發生錯誤!"
                })
            }
        },
    },
    computed: {
        ntpListView(){
            return this.viewNtpList[this.ntpSearchMode]
        },
        userInfo(){
            return this.$store.state.userInfo
        }
    },
    async activated(){
        this.userPermission = -1;
        this.pageLoading(true);
        this.viewMoreCount = 0;
        this.isShowMoreButton = true;
        this.viewNtpList.all = [];
        this.viewNtpList.search = [];
        this.$nextTick(() => {
            this.tableLoading = true;
        })
        let res = await api.getNtpReportList();
        if(!res.error_status){
            res.sort(function(a, b){
                if(a.site > 7){
                    return 1
                } else if(a.site > b.site){
                    return 1
                } else if(a.site < b.site){
                    return -1
                } else {
                    return 0
                }
            })
            setTimeout(function(){
                this.tableLoading = false;
                setTimeout(function(){
                    this.pageLoading(false);
                    this.userPermission = 1;
                    this.ntpList.all = res;
                    this.ntpReportListIteration();
                }.bind(this), 300);
            }.bind(this), 300);
        } else if(res.error_status == '403'){
            this.pageLoading(false);
            this.userPermission = 0;
            this.haveService = false;
            this.tableLoading = false;
        } else if(res.error_status != '401' && res.error_status != '504'){
            this.pageLoading(false);
            this.userPermission = 0;
            this.$message.error({
                duration: 2500,
                showClose: true,
                message: "發生錯誤!"
            })
            this.tableLoading = false;
        }
        let userRes = await api.getUserLogin();
        if(!userRes.error_status){
            let ServerTime = userRes.server_time;
            let serverMonth = ServerTime.split("").slice(5,7).join("") - 1;
            serverMonth = serverMonth < 10 ? '0' + serverMonth : serverMonth;
            let serverYear = ServerTime.split("").slice(0,4).join("");
            if(serverMonth == '01'){
                serverYear -= 1;
                serverMonth = '12';
            }
            this.serverTime = `${serverYear}_${serverMonth}`;
        }
        await this.getUserCompanyInfo();
        await this.getUserService();
        if(this.serviceList.find(item => item.services_title == 'NTP Services Reports' && item.status == 0)){
            this.canAddNewApplyItem = false;
        }
    },
    watch: {
        tableLoading(value){
            if(document.querySelector(".ntpReport-header")){
                let hasData = document.querySelector(".paca-table__body");
                let loadingStyle = "";
                let asideWidth = document.querySelector(".el-aside").offsetWidth;
                if(hasData){
                    loadingStyle = hasData.offsetHeight > document.querySelector(".el-main").offsetHeight/2 ? 'screen-align' : 'empty-align';
                }
                if(asideWidth > 150){
                    loadingStyle += " collapse-open";
                }else if(asideWidth > 50){
                    loadingStyle += " collapse-exist";
                }
                if(value == true){
                    this.loadingMethod = this.$loading({
                        lock: true,
                        target: '.paca-table__empty',
                        text: '搜尋中',
                        spinner: 'el-icon-loading',
                        background: 'rgba(255,255,255,0.8)',
                        customClass: loadingStyle
                    });
                }else{
                    if(this.loadingMethod != null){
                        this.loadingMethod.close();
                    }
                }
            }
        }
    },
}
</script>